
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, ValidationErrors, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { GenericIdbaComponent } from './generic-idba.component';
import { GenericIdbaService } from '../../services/generic-idba-service.service';
import { TrataExcessaoService } from '../../services/trata-excessao.service';

@Component({
  standalone: false,
  selector: 'app-abstract-idba-form-component',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class GenericIdbaFormComponent extends GenericIdbaComponent {
  public title: String;
  public rowid: string;
  public visualizar: boolean = false;

  public service: GenericIdbaService;
  public router = inject(Router);
  public activatedRoute = inject(ActivatedRoute);
  public formBuilder = inject(UntypedFormBuilder);

  override ngOnInit(): void {
    super.ngOnInit();
    this.createForm();
    this.activatedRoute.params.subscribe((data) => {
      this.title = "Novo";

      this.visualizar = (data['v?'] || data['v']);

      if (data['id?']) {
        this.rowid = data['id?'];
      } else if (data['id']) {
        this.rowid = data['id'];
      }

      if (data['v?']) {
        this.visualizar = true;
        Object.keys(this.form.controls).forEach((key: string) => {
          const abstractControl = this.form.controls[key];
          abstractControl.disable();
        });
      }

      if (this.rowid) {
        this.title = 'Editar';
        this.service
          .pesquisar(this.rowid)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (response) => {
              const registro = response.body?.data?.registro;
              if (!registro || !Array.isArray(registro) || registro.length === 0) {
                const msg = response.body?.retorno?.erros?.[0]?.errorDescription
                  || response.body?.ErrMsg
                  || 'Registro não encontrado ou retorno inválido.';
                this.snackBar.openSnackBar(msg, null, 'Error');
                return;
              }
              const primeiro = registro[0];
              if (primeiro !== null && typeof primeiro === 'object') {
                this.service.model = this.service.model.convertToModel(primeiro);
                this.populateForm();
              } else {
                this.snackBar.openSnackBar('Resposta do servidor em formato inválido.', null, 'Error');
              }
            }
          });
      }else{
        this.title = "Novo";
        this.initializeForm();
      }

      this.activatedRoute.queryParams.subscribe(queryParams => {
        this.visualizar = queryParams['visualizando'] === 'true';
        if (this.visualizar) {
          this.title = "Consultar";
          Object.keys(this.form.controls).forEach((key: string) => {
            const abstractControl = this.form.controls[key];
            abstractControl.disable();
          });
        }
      });

    });
  }

  get canSave(): boolean {
    return Boolean(this.acesso?.indInclusao || this.acesso?.indAlteracao);
  }

  initializeForm() {}

  populateForm() {
    throw new Error(
      "Implementar função 'populateForm' com override na classe principal!"
    );
  }

  createForm() {
    throw new Error(
      "Implementar função 'createForm' com override na classe principal!"
    );
  }

  pesquisar() {
    throw new Error(
      "Implementar função 'pesquisar' com override na classe principal!"
    );
  }

  navigateBack() {
    const returnUrl = this.activatedRoute.snapshot.queryParamMap.get('returnUrl');
    if (returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')) {
      this.router.navigateByUrl(returnUrl);
      return;
    }

    var urlBack = '';
    var arrayUrl = this.router.url.split('/');

    if (arrayUrl[arrayUrl.length - 1] == 'true') {
      arrayUrl.splice(arrayUrl.length - 1);
    }

    arrayUrl.map((termo, index) => {
      if (termo) {
        if (index != arrayUrl.length - 1) {
          urlBack = urlBack + '/' + termo;
        }
      }
    });

    this.router.navigate([urlBack]);
  }

  nextCommand(result) {
    this.showMessage('Registro salvo com sucesso!');
    this.navigateBack();
  }

  errorCommand(err) {
    // TrataExcessaoService.TrataExcessao(err, this.authService, this.snackBar);
  }

  completeCommand() {
  }

  override consultaPermissaoAcesso() {
    this.acessoService
      .pesquisaPermissaoAcesso()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.acesso = response.body.data;
          if (this.acesso?.funcoes) {
            this.acesso.funcoes.forEach(element => {
              this.funcoes[element.codigo] = element.ativo;
            });
          }
          this.validaAcesso();
        }
      });
  }

  private validaAcesso() {
    if (!this.acesso?.indInclusao) {
      this.showMessage('Você não tem permissão a esta operação', 'Error');
      this.router.navigate(['/home']);
      return;
    }

    this.activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data['id?']) {
          if (!this.acesso?.indAlteracao) {
            this.showMessage('Você Não Tem Permissão a Esta Operação', 'Error');
            this.router.navigate(['/home']);
          }
        }
      });

    this.getGenericParams();

  }

  override verificaSeleciona(event, campo: string, campoCodigo: string) {
    if (event.srcElement.value === '') {
      this.form.controls[campo].setValue('');
      this.form.controls[campoCodigo].setValue(0);
    }
  }

  prepareServiceModel(): boolean {
    throw new Error(
      "Implementar função 'prepareServiceModel' com override na classe principal!"
    );
    /*
    this.service.model.idPessoa  = this.form.controls["integrado"].value.id
    this.service.model.idTecnico = this.form.controls["tecnico"].value.id;
    */
  }

  preencheCampoModel(nomeCampoService: string, campoCodigo: string | undefined = undefined, campoForm: string | undefined = undefined) {
    if (campoForm) {
      if (campoCodigo)
        this.service.model[nomeCampoService] = this.form.controls[campoForm].value?.[campoCodigo];
      else
        this.service.model[nomeCampoService] = this.form.controls[campoForm].value;
    }
    else {
      if (campoCodigo)
        this.service.model[nomeCampoService] = this.form.controls[nomeCampoService].value?.[campoCodigo];
      else
        this.service.model[nomeCampoService] = this.form.controls[nomeCampoService].value;
    }
  }

  preencheCampoForm(nomeCampoForm: string, nomeCampoModel: string | null = null) {
    if (nomeCampoModel)
      this.form.controls[nomeCampoForm].setValue(this.service.model[nomeCampoModel]);
    else
      this.form.controls[nomeCampoForm].setValue(this.service.model[nomeCampoForm]);
  }

  salvar() {
    this.getFormValidationErrors();
    if (this.form.valid) {
      this.service.model.rowid = this.rowid;
      this.prepareServiceModel();
      this.service
        .saveModel()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (results) => {
            this.nextCommand(results);
          },

          error: (err: any) => {
            this.errorCommand(err);
          },
          complete: () => {
            this.completeCommand();
          },
        });
    } else {
      this.form.markAllAsTouched();
      this.showMessage('Campos obrigatórios não foram preenchidos', 'Warn');
    }
  }

  getFormValidationErrors() {
    this.form.markAllAsTouched();
    Object.keys(this.form.controls).forEach(key => {
      const controlErrors: ValidationErrors | null | undefined = this.form?.get(key)?.errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          console.log(key, keyError, this.form?.get(key)?.value);
        });
      }
    });

  }

  setRequired(required: boolean, controlName: string, setNull: boolean = true, form: any = null) {
    const formGroup = form ? form : this.form;
    if (required) {
      formGroup.controls[controlName].setValidators([Validators.required]);
    } else {
      formGroup.controls[controlName].clearValidators();
    }

    if (setNull) {
      formGroup.controls[controlName].setValue(null);
    }

    formGroup.controls[controlName].updateValueAndValidity();
  }

}

